import { ClassProvider, ErrorHandler } from '@angular/core'

import { GlobalErrorHandler } from '../services/global-error-handler.service'

export const ERROR_HANLDER_PROVIDER: ClassProvider = { provide: ErrorHandler, useClass: GlobalErrorHandler }
